module.exports = __webpack_public_path__ + "files/acf7e8258ad10f0aa487e2ccc2825d33.png";